export default "__VITE_ASSET__Bmgbjm2L__"